export enum SortDirection {
  DESC = 'DESC',
  ASC = 'ASC'
}
